"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSliderThumbnail = void 0;
var _react_image_sliderModule = _interopRequireDefault(require("@albelli/arc-3/lib/react_image_slider.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = require("keen-slider/react");
var _propTypes = require("prop-types");
var _react2 = _interopRequireWildcard(require("react"));
var _SliderPicture = require("./SliderPicture");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ThumbnailPlugin(mainRef) {
  return slider => {
    function removeActive() {
      slider.slides.forEach(slide => {
        slide.classList.remove(_react_image_sliderModule.default["--active"]);
      });
    }
    function addActive(idx) {
      slider.slides[idx].classList.add(_react_image_sliderModule.default["--active"]);
    }
    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          if (mainRef.current) mainRef.current.moveToIdx(idx);
        });
      });
    }
    slider.on("created", () => {
      if (!mainRef.current) return;
      slider.track.details && addActive(slider.track.details.rel);
      addClickEvents();
      mainRef.current.on("animationStarted", main => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
      });
    });
  };
}
const horizontalOpts = {
  initial: 0,
  loop: false,
  mode: "free-snap",
  rtl: false,
  slides: {
    perView: "auto",
    spacing: 16
  }
};
const ImageSliderThumbnail = _ref => {
  let {
    sliderRef,
    instanceRef,
    images,
    imageSizes,
    vertical
  } = _ref;
  const pictureInitialSizing = (imageSizes.small || imageSizes.medium || imageSizes.large)["1x"];
  const pictureInitialSize = (0, _react2.useMemo)(() => ({
    height: +pictureInitialSizing.replace(/d=(\d+)x\d+/, (_, height) => height),
    width: +pictureInitialSizing.replace(/d=\d+x(\d+)/, (_, width) => width)
  }), [pictureInitialSizing]);
  const [thumbnailRef] = (0, _react.useKeenSlider)(vertical ? {
    initial: 0,
    loop: false,
    mode: "free",
    rtl: false,
    slides: size => {
      return images.map((_, idx) => {
        const imageSize = pictureInitialSize.height / size;
        const spacing = 0.01;
        const maxOffsetPosition = idx === images.length - 1 ? 1 : 2;
        return {
          origin: Math.min(1 - imageSize * maxOffsetPosition, imageSize * idx + spacing * idx),
          size: imageSize,
          spacing
        };
      });
    },
    vertical: true
  } : horizontalOpts, [ThumbnailPlugin(instanceRef)]);
  return /*#__PURE__*/_react2.default.createElement("div", {
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__carousel"])
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__carousel__wrapper"])
  }, /*#__PURE__*/_react2.default.createElement("div", {
    ref: thumbnailRef,
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__carousel__wrapper__inner"], "keen-slider")
  }, images.map((_ref2, idx) => {
    let {
      src,
      alt
    } = _ref2;
    return /*#__PURE__*/_react2.default.createElement(_SliderPicture.SliderPicture, {
      key: idx,
      src: src,
      alt: alt,
      height: pictureInitialSize.height,
      width: pictureInitialSize.width,
      imageSizes: imageSizes,
      imageIndex: idx,
      dataCy: "Slider-ThumbnailPicture-".concat(idx)
    });
  }))));
};
exports.ImageSliderThumbnail = ImageSliderThumbnail;
ImageSliderThumbnail.propTypes = {
  /** Array of objects like { src: 'pathToImage', alt: 'alt text' } */
  images: _propTypes.PropTypes.array,
  /** Should thumbnail be vertical */
  vertical: _propTypes.PropTypes.bool,
  /** sizes object for media breakpoints uploads */
  imageSizes: _propTypes.PropTypes.object,
  /** refs to main slider, to keep both in sync */
  sliderRef: _propTypes.PropTypes.func,
  instanceRef: _propTypes.PropTypes.object
};